import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

// Live countdown shown only when a deal expires within the next 48 hours.
export default function DealCountdown({ expires }) {
  const target = expires ? new Date(expires).getTime() : null;
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!target) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) return null;
  const ms = target - now;
  if (ms <= 0 || ms > 48 * 3600 * 1000) return null;

  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  const s = Math.floor((ms % 60000) / 1000);

  const Cell = ({ v, label }) => (
    <div className="flex flex-col items-center">
      <span className="font-mono font-bold text-lg text-white tabular-nums leading-none">{pad(v)}</span>
      <span className="text-[9px] uppercase tracking-wide text-white/70 mt-0.5">{label}</span>
    </div>
  );

  return (
    <div data-testid="deal-countdown" className="mt-3 inline-flex items-center gap-3 rounded-lg bg-sam-crimson px-3.5 py-2 shadow-sm">
      <span className="inline-flex items-center gap-1 text-xs font-bold text-white uppercase tracking-wide"><Clock className="h-3.5 w-3.5" />Ends in</span>
      <div className="flex items-center gap-2">
        <Cell v={h} label="hrs" /><span className="text-white/50 font-bold -mt-2">:</span>
        <Cell v={m} label="min" /><span className="text-white/50 font-bold -mt-2">:</span>
        <Cell v={s} label="sec" />
      </div>
    </div>
  );
}
